(() => {
 const init = scope => scope.querySelectorAll('[data-uvora-bundles]').forEach(root => {
  if(root.dataset.readyOffers) return;
  root.dataset.readyOffers='true';
  const radios=[...root.querySelectorAll('[data-uvora-offer]')];
  const input=root.querySelector('[data-uvora-offer-quantity]');
  const form=document.getElementById(input?.getAttribute('form'));
  const formatter=new Intl.NumberFormat(document.documentElement.lang||'fr-FR',{style:'currency',currency:'EUR'});
  const update=()=>{
   const selected=radios.find(r=>r.checked);if(!selected)return;
   if(input){input.value=selected.dataset.quantity;input.dispatchEvent(new Event('change',{bubbles:true}));}
   const price=formatter.format(Number(selected.dataset.total)/100);
   const button=form?.querySelector('button[type="submit"]');
   if(button){let node=button.querySelector('[data-uvora-button-price]');if(!node){node=document.createElement('span');node.dataset.uvoraButtonPrice='';node.setAttribute('aria-hidden','true');button.insertBefore(node,button.querySelector('.add-to-cart__added'));}node.textContent=' · '+price;button.setAttribute('aria-label','Ajouter au panier · '+price);}
   const sticky=document.querySelector('[data-uvora-sticky]');
   if(sticky){const p=sticky.querySelector('small');if(p)p.textContent=price;const b=sticky.querySelector('button');if(b&&button)b.disabled=button.disabled;}
  };
  radios.forEach(r=>r.addEventListener('change',update));update();
  // Native variant changes can replace the button; restore its selected pack price.
  document.addEventListener('variant:update',update);
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
 document.addEventListener('shopify:section:load',e=>init(e.target));
})();

(() => {
 const updateDispatch = () => {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('fr-FR',{timeZone:'Europe/Paris',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date()).map(p=>[p.type,p.value]));
  const tomorrow = new Date(Date.UTC(Number(parts.year),Number(parts.month)-1,Number(parts.day)+1));
  const label = new Intl.DateTimeFormat('fr-FR',{timeZone:'UTC',day:'2-digit',month:'2-digit'}).format(tomorrow);
  document.querySelectorAll('[data-uvora-dispatch]').forEach(t=>{t.textContent=label;t.dateTime=tomorrow.toISOString().slice(0,10);});
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',updateDispatch,{once:true});else updateDispatch();
 document.addEventListener('shopify:section:load',updateDispatch);
})();
